import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ActiveEQuery } from '../../models/active-e-query';
import { EQueryQuestionInfo } from '../../e-query-details/questions/e-query-question-info';

@Component({
    selector: 'active-e-query-questions',
    template: require('./active-e-query-questions.component.html'),
    styles: [require('./active-e-query-questions.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveEQueryQuestionsComponent {
    @Input()
    public activeEQuery: ActiveEQuery;

    public getQuestions() {
        return this.activeEQuery.questions.map<EQueryQuestionInfo>(pq => ({
            queryText: pq.queryText,
            issueTypeDescription: pq.issueDescription,
            issueType: pq.issueType
        }));
    }
}
